<template>
  <div class="shadow agreement-container" style="height: auto">
    <h4 style="text-align: left">
      <b>Agreement Overview</b>
    </h4>
    <div class="agreement">
      <div class="col" :style="mode != 'all' ? 'width:100% !important' : ''">
        <div class="row">
          <div class="column-1">
            <p>Agreement number:</p>
          </div>
          <div class="column-2">
            <p>{{ user.case.agreementNo }}</p>
          </div>
        </div>
        <div class="row">
          <div class="column-1">
            <p>Current arrears:</p>
          </div>
          <div class="column-2 monetary">
            <p style="width: 70%">£</p>
            <p style="width: 30%">
              {{ Number(user.case.totalArrears).toFixed(2) }}
            </p>
          </div>
        </div>
        <div class="row">
          <div class="column-1">
            <p>Total fees:</p>
          </div>
          <div class="column-2 monetary">
            <p style="width: 70%">£</p>
            <p style="width: 30%">
              {{ Number(user.case.totalFees).toFixed(2) }}
            </p>
          </div>
        </div>
        <div class="row">
          <div class="column-1">
            <p>Balance:</p>
          </div>
          <div class="column-2 monetary">
            <p style="width: 70%">£</p>
            <p style="width: 30%">{{ Number(user.case.balance).toFixed(2) }}</p>
          </div>
        </div>
      </div>
      <div class="col" v-if="mode == 'all'">
        <div class="row">
          <div class="column-1">
            <p>Paid to date:</p>
          </div>
          <div class="column-2 monetary">
            <p style="width: 70%">£</p>
            <p style="width: 30%">
              {{ Number(user.case.paidToDate).toFixed(2) }}
            </p>
          </div>
        </div>
        <div class="row">
          <div class="column-1">
            <p>Days in arrears:</p>
          </div>
          <div class="column-2">
            <p>{{ user.case.daysInArrears }}</p>
          </div>
        </div>
        <div class="row">
          <div class="column-1">
            <p>Monthly installment amount:</p>
          </div>
          <div class="column-2 monetary">
            <p style="width: 70%">£</p>
            <p style="width: 30%">
              {{ Number(user.case.nextPaymentValue).toFixed(2) }}
            </p>
          </div>
        </div>
        <div class="row">
          <div class="column-1">
            <p>Payment method:</p>
          </div>
          <div class="column-2">
            <p>{{ user.case.paymentMethodText }}</p>
          </div>
        </div>
      </div>
      <div class="col" v-if="mode == 'all'">
        <div class="row">
          <div class="column-1">
            <p>Next payment date:</p>
          </div>
          <div class="column-2">
            <p>{{ formatDate(user.case.nextPaymentDate) }}</p>
          </div>
        </div>
        <div class="row">
          <div class="column-1">
            <p>Last payment date:</p>
          </div>
          <div class="column-2">
            <p>{{ formatDate(user.case.prevPaymentDate) }}</p>
          </div>
        </div>
        <div class="row">
          <div class="column-1">
            <p>Start Date:</p>
          </div>
          <div class="column-2">
            <p>{{ startDate }}</p>
          </div>
        </div>
        <div class="row">
          <div class="column-1">
            <p>End Date:</p>
          </div>
          <div class="column-2">
            <p>{{ endDate }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AgreementPanel",

  props: {
    user: Object,
    mode: String,
  },

  computed: {
    //Null values cause the panel not to render, using computed props to avoid this
    startDate() {
      if (this.user.startDate == null) return "NA";
      else return this.formatDate(this.user.startDate);
    },

    endDate() {
      if (this.user.endDate == null) return "NA";
      else return this.formatDate(this.user.endDate);
    },
  },
};
</script>

<style scoped>
.shadow {
  -webkit-box-shadow: 3px 2px 14px -1px rgba(204, 204, 204, 1);
  -moz-box-shadow: 3px 2px 14px -1px rgba(204, 204, 204, 1);
  box-shadow: 3px 2px 14px -1px rgba(204, 204, 204, 1);
  background-color: white;
  border-bottom: 2px solid #41b3a3;
}

.row {
  display: flex;
  width: 95%;
  text-align: left;
}

.column-2 {
  flex: 60%;
  margin-left: 5px;
  text-align: right;
}

.column-1 {
  flex: 40%;
  text-align: left;
  margin-left: 10px;
}

.agreement-container {
  margin-bottom: 10px;
  padding: 5px;
}

@media screen and (max-width: 800px) {
  .agreement {
    flex-direction: column !important;
  }

  .col {
    width: 100% !important;
  }
}

.agreement {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin-left: 10px;
}

.agreement .col {
  width: 33%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.agreement p {
  margin: 0;
  padding-top: 5px;
  padding-bottom: 5px;
}

.agreement h4 {
  padding: 0;
  margin: 0;
}

.monetary {
  display: flex;
  justify-content: space-between;
  text-align: right;
}
</style>